var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-weight"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8 20C18.9201 20 19.4802 20 19.908 19.782C20.2843 19.5903 20.5903 19.2843 20.782 18.908C21 18.4802 21 17.9201 21 16.8V16.2C21 15.0799 21 14.5198 20.782 14.092C20.5903 13.7157 20.2843 13.4097 19.908 13.218C19.4802 13 18.9201 13 17.8 13L6.2 13C5.0799 13 4.51984 13 4.09202 13.218C3.71569 13.4097 3.40973 13.7157 3.21799 14.092C3 14.5198 3 15.0799 3 16.2V16.8C3 17.9201 3 18.4802 3.21799 18.908C3.40973 19.2843 3.71569 19.5903 4.09202 19.782C4.51984 20 5.07989 20 6.2 20H17.8Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.5C3 5.66047 3 5.24071 3.15362 4.91591C3.31188 4.58128 3.58128 4.31188 3.91591 4.15362C4.24071 4 4.66047 4 5.5 4H14.5C15.3395 4 15.7593 4 16.0841 4.15362C16.4187 4.31188 16.6881 4.58128 16.8464 4.91591C17 5.24071 17 5.66047 17 6.5C17 7.33953 17 7.75929 16.8464 8.08409C16.6881 8.41872 16.4187 8.68812 16.0841 8.84638C15.7593 9 15.3395 9 14.5 9H5.5C4.66047 9 4.24071 9 3.91591 8.84638C3.58128 8.68812 3.31188 8.41872 3.15362 8.08409C3 7.75929 3 7.33953 3 6.5Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarWeight);
export default __webpack_public_path__ + "static/media/bar-weight.2f3b89c38570851a0cc2276b406eeb90.svg";
export { ForwardRef as ReactComponent };